export const set_user = (state, user) => (state.user = user);
